import { useEffect, useState } from "react";
import { Tooltip } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { getAppointment } from "../../api/Scheduling/appointments";
import "./freeAppointmentTime.css";

export async function appointmentTimeIsStillOpen(encounter) {
  const appointmentId = encounter?.appointmentId;
  const organizationRef = encounter?.orgId || String(encounter?.serviceProvider?.reference || "").split("/")[1];
  if (!appointmentId || !organizationRef) return false;
  try {
    const result = await getAppointment({ organizationRef, appointmentId });
    const appointment = result?.appointment || result;
    const end = new Date(appointment?.endsAt).getTime();
    return Boolean(appointment?.endsAt) && !Number.isNaN(end) && Date.now() < end;
  } catch {
    return false;
  }
}

export function useAppointmentTimeCanBeFreed(encounter) {
  const [canFree, setCanFree] = useState(false);
  const encounterId = encounter?.id;
  const appointmentId = encounter?.appointmentId;
  const organizationRef = encounter?.orgId || encounter?.serviceProvider?.reference;
  useEffect(() => {
    let cancelled = false;
    setCanFree(false);
    appointmentTimeIsStillOpen(encounter).then((open) => {
      if (!cancelled) setCanFree(open);
    });
    return () => { cancelled = true; };
  }, [encounterId, appointmentId, organizationRef]);
  return canFree;
}

export function FreeAppointmentTimeChoice({ checked, onChange }) {
  return (
    <div className={`free-time-choice${checked ? " is-on" : ""}`}>
      <label>
        <input
          type="checkbox"
          checked={checked}
          onChange={(event) => onChange(event.target.checked)}
        />
        <span className="free-time-switch" aria-hidden="true" />
        <span className="free-time-title">Free time</span>
        <span className="free-time-state">{checked ? "On" : "Off"}</span>
      </label>
      <Tooltip
        title="Off keeps this appointment time blocked. Turn on only if you finished early and want to free time for other patients."
        placement="top"
        arrow
        componentsProps={{
          tooltip: {
            sx: {
              fontSize: "15px",
              lineHeight: 1.45,
              maxWidth: 320,
              padding: "10px 12px",
            },
          },
        }}
      >
        <button type="button" className="free-time-info" aria-label="About freeing this time">
          <InfoOutlinedIcon fontSize="inherit" />
        </button>
      </Tooltip>
    </div>
  );
}
